import React, { useContext, useEffect, useState } from 'react';
import Layout from '../Component/layout/main-layout';
import { useTranslation } from 'react-i18next';
import { ArrowDropDown } from '@mui/icons-material';
import LotAngle from '../Images/icons/LotAngle.svg'
import layoutBgImg from '../Images/layout/faq.jpg'
import { Context } from '../Store/context';
import { GetFaq } from '../api/Queries/get';
import Loading from '../Component/loader/loader';
import GlobalLayout from '../Component/layout/global-layout';

const Faq = () => {
  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [faq, setFaq] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { showError } = useContext(Context);

  useEffect(() => {
    setIsLoading(true)
    const getNews = async () => {
      try {
        const data = await GetFaq()
        setIsLoading(false)
        setFaq(data)
      } catch (error) {
        showError(error.message);
        setIsLoading(false)
      }
    }
    getNews()
  }, [showError])

  const getCategory = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.category_name_rus;
    } else if (currentLang === 'en') {
      return laws.category_name_eng;
    }
    return laws.category_name_tm;
  };

  // Group FAQs by category
  const groupedFaqs = faq.reduce((acc, item) => {
    const category = getCategory(item) || t('other');
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});

  const getQuestion = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.rus_question;
    } else if (currentLang === 'en') {
      return laws.eng_question;
    }
    return laws.tm_question;
  };

  const getAnswer = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.rus_answer;
    } else if (currentLang === 'en') {
      return laws.eng_answer;
    }
    return laws.tm_answer;
  };

  const toggleCategory = (category) => {
    setExpandedCategory(expandedCategory === category ? null : category);
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <GlobalLayout
      title={`${t('faq')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Kop soralyan soraglar, Köp soralýan soraglar, Часто задаваемые вопросы"
    >
      <div className='mb-20'>
        <Layout
          title={t('faq')}
          layoutBgImg={layoutBgImg}
        />
        <div className='w-full media'>

          <div className='bg-white dark:bg-dark-box mt-8 pt-4 pb-1'>
            {isLoading ? <Loading /> : (
              Object.entries(groupedFaqs).map(([category, items]) => (
                <div key={category} className='mb-4'>
                  {/* Category Title */}
                  <div
                    className='cursor-pointer flex p-3 gap-4
                               items-center justify-between'
                    onClick={() => toggleCategory(category)}
                  >
                    <h2 className='text-lg font-semibold flex gap-3 items-center
                                   hover:text-primary dark:text-dark-text'>
                      <img src={LotAngle} alt="angle" />
                      {category}
                    </h2>
                    <span className={`transform transition-transform duration-300 
                                     ${expandedCategory === category ? 'rotate-180' 
                                                                     : 'rotate-0'}`}
                    >
                      <ArrowDropDown className='text-blackOpacity dark:text-dark-text'/>
                    </span>
                  </div>

                  {/* FAQ Items under this Category */}
                  {expandedCategory === category && (
                    <div className='mx-6'>
                      {items.map((item, index) => (
                        <div
                            key={item.id}
                            className='border-b border-b-border'>
                          <div
                            onClick={() => toggleAccordion(index)}
                            className='cursor-pointer pt-4 pb-2 flex text-black
                                        dark:text-dark-text items-center gap-2'
                          >
                            <span>{index+1}.</span>
                            <h3 className={`transition-colors  duration-300 
                                           ${activeIndex === index ? 'text-primary' : ''}`}
                            >     {getQuestion(item)}
                            </h3>
                          </div>
                          {activeIndex === index && (
                            <div className='px-4 my-4 text-justify border-l-4 
                                            dark:text-dark-text border-primary'>
                              <p>{getAnswer(item)}</p>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </GlobalLayout>
  );
};

export default Faq;
